import React, { useState, useRef } from 'react'
import { Dropdown } from 'react-bootstrap'
import UserProfile from '../../../assets/images/user-profile.png'
import { ReactComponent as IconStore } from '../../../assets/images/icons/icon-store.svg'
import { ReactComponent as IconCollapseToggle } from '../../../assets/images/icons/icon-collapse-toggle.svg'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { SELLER_LOGOUT, SELLER_VIEWPROFILE, SELLER_VIEW_PROFILE_DETAILS } from '../../../Redux-Toolkit/Actions/sagaActions'
import { settings } from '../../../config/routingConsts'
import { useEffect } from 'react'
import ModalPopup from '../../Modal/ModalPopup'
import Button from '../../Button'
import WarningLogoutRedIcon from '../../../assets/images/icons/sellerLogout-old.svg'



const DashBoardHeader = ({ setChildValue, childValue }) => {
    const { t } = useTranslation()
    const sideMenu = t('common', { returnObjects: true })
    const { seller } = useSelector((action) => action.authSlice)
    const {data} = useSelector((action)=>action.settingsSlice)
    const { state } = useLocation()
    const navigate = useNavigate()
    const handleToggle = () => {
        setChildValue(!childValue)
    }
    const dispatch = useDispatch()
    const [logoutModalShow,setLogoutModalShow] = useState(false)
    useEffect(()=>{
        dispatch({type:SELLER_VIEWPROFILE})
    },[])
    
    return (
        <>
        <div className="admin-header">
            <div className="header-left">
                {/* <div class={`collapse-toggle ${childValue === false ? 'active' : ''}`} onClick={handleToggle}><i></i></div> */}
                <div className="collapse-toggle-icon" onClick={handleToggle}>
                    <IconCollapseToggle />
                </div>
                <h1>{state ?? 'Dashboard'}</h1>
            </div>
            <div className="header-right">
                <Dropdown>
                    <Dropdown.Toggle variant=" primary" id="dropdown-basic">
                        {/* <img src={UserProfile} alt="user-profile" /> */}
                        <img src={data?.profilePic} alt = "user-profile"/>
                        {/* Mark Jonsan */}
                        {data?.fullName}
                        {/* {seller.fullName} */}
                        {/* Hiren Patel */}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        <div className="store-head">
                            <span>
                                <IconStore />
                            </span>
                            <div className="detail">
                                <p>Store Name</p>
                                <h3>{data?.storeName}</h3>
                                {/* <h3>Moon Light Store</h3> */}
                            </div>
                        </div>
                        <Dropdown.Item onClick={()=>{navigate(settings)}}>
                            {sideMenu.ProfileSettings}
                        </Dropdown.Item>
                        <Dropdown.Item
                            onClick={() => {
                                setLogoutModalShow(true)
                                // dispatch({ type: SELLER_LOGOUT })
                            }}
                        >
                            {sideMenu.Logout}
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        </div>

     {/* Logout Modal For Conformation */}
    <ModalPopup
                show={logoutModalShow}
                handleClose={() => setLogoutModalShow(true)}
                handleShow={() => setLogoutModalShow(true)}
                cname="accept-item confirm-modal delete-modal"
            >
                <img src={WarningLogoutRedIcon} alt="" />
                <h2>Are You Sure? Do you want to logout?</h2>
                <div className="modal-btn-group">
                    <Button
                        type="button"
                        commonClass="border-red-btn modal-btn"
                        text={'No'}
                        onClick={() => setLogoutModalShow(false)}
                    />
                    <Button
                        type="button"
                        commonClass="solid-red-btn modal-btn"
                        text={'Yes'}
                        onClick={() => {
                            dispatch({ type: SELLER_LOGOUT })
                            // onDeleteYesBtnClick(delID)
                            // setDeleteModalShow(false)
                            // dispatch(sellerDeleteProductSuccess(delID))
                        }}
                    />
                </div>
            </ModalPopup>
   {/* End Logout modal  */}

    </>

    )
}

export default DashBoardHeader
